import bwipjs from 'bwip-js';
import { http } from "@/helpers/http";
import { checkSurcharge } from './shippingMethod';
import APP_URL from './urls';

function textToImage(options) {
    try {
        let canvas = document.querySelector("#canvas");
        bwipjs.toCanvas(canvas, options);
        return canvas.toDataURL('image/png')
    } catch (e) {
        console.log(e)
        return null
    }
}

const hidePhoneNo = (phoneNo) => {
    if (phoneNo && phoneNo.length > 1) {
        let prefix = phoneNo[0] + phoneNo[1] + phoneNo[2] + "";
        let suffix = phoneNo.charAt(phoneNo.length - 1) + phoneNo.charAt(phoneNo.length - 2) + phoneNo.charAt(phoneNo.length - 3) + "";
        let body = "";
        for (let i = 0; i < phoneNo.length - 6; i++) body += "*";
        return prefix + body + suffix;
    }
    return phoneNo || "";
};

function preProcess(orderDetails, printer) {

    try {
        // shipping method - convert to lowercase
        orderDetails.shippingMethod = orderDetails.shippingMethod.toLowerCase();

        // products
        if (orderDetails.products) orderDetails.products = Object.fromEntries(
            Object.entries(orderDetails.products).sort(([, a], [, b]) => a.sortIndex - b.sortIndex)
        );

        // sokochan order id
        if (!orderDetails.sokochanOrderId) orderDetails.sokochanOrderId = "N/A";

        // tracking No
        if (!orderDetails.trackingNo) orderDetails.trackingNo = "N/A";

        if (!orderDetails.sortingCode) orderDetails.sortingCode = "";

        // remarks
        if (!orderDetails.remarks) orderDetails.remarks = "";
        else {
            if (printer !== "proship_v3")
                orderDetails.remarks = "หมายเหตุ: " + orderDetails.remarks;
            else orderDetails.remarks = orderDetails.remarks;
        }

        if (!printer || printer && (printer !== "x100"))
            orderDetails.remarks = orderDetails.remarks.replace(/\//g, "\n");

        // fb/line
        if (orderDetails.customer && orderDetails.customer.showSocialLinkOnLabel) {
            if (printer !== 'proship_v3p')
                orderDetails.remarks += " " + ": " + orderDetails.customer.socialLink;
        }

        // address
        if (orderDetails.customer && orderDetails.customer.address) {
            if (!orderDetails.customer.address.address)
                orderDetails.customer.address.address = "";
            if (!orderDetails.customer.address.district)
                orderDetails.customer.address.district = "";
            if (!orderDetails.customer.address.subDistrict)
                orderDetails.customer.address.subDistrict = "";
            if (!orderDetails.customer.address.province)
                orderDetails.customer.address.province = "";
            if (!orderDetails.customer.address.zipcode)
                orderDetails.customer.address.zipcode = "     ";

            orderDetails.customer.address.address = orderDetails.customer.address.address.replace(/􀀀/g, "");
            orderDetails.customer.address.district = orderDetails.customer.address.district.replace(/􀀀/g, "");
            orderDetails.customer.address.subDistrict = orderDetails.customer.address.subDistrict.replace(/􀀀/g, "");
            orderDetails.customer.address.province = orderDetails.customer.address.province.replace(/􀀀/g, "");
        }

        // label top logo
        orderDetails.logo = "logo_" + orderDetails.shippingMethod.toLowerCase() + ".png";

        if (orderDetails.codAmount && typeof orderDetails.codAmount == "string") {
            orderDetails.codAmount = parseFloat(orderDetails.codAmount.replace(/\D/g, ''));
        }

        if (orderDetails.shippingMethod.includes("kerry")) {
            if (orderDetails && orderDetails.customer && orderDetails.customer.phoneNo) {
                orderDetails.customer.phoneNo = orderDetails.customer.phoneNo.replace(/\d{4}$/, "xxxx");
            }
            if (orderDetails && orderDetails.shop && orderDetails.shop.phoneNo) {
                orderDetails.shop.phoneNo = orderDetails.shop.phoneNo.replace(/\d{4}$/, "xxxx");
            }
        }

        if (orderDetails.shippingMethod.includes("flash")) {
            if (orderDetails && orderDetails.customer && orderDetails.customer.phoneNo) {
                orderDetails.customer.phoneNo = hidePhoneNo(orderDetails.customer.phoneNo)
            }
        }

        return orderDetails;
    } catch (e) {
        console.log("ERROR preprocess", e);
        return orderDetails;
    }
};

function generateLabel(order) {
    order = preProcess(order);
    const RENDERER = {
        "kerry": () => {
            let cust = order.customer;
            let zipChars = (cust.address.zipcode + "").split("");
            let receiverInfoTxt = `${cust.name} (${cust.phoneNo || cust.mobileNo || ""
                }) <br> ${cust.address.address} <br> ${cust.address.subDistrict}, ${cust.address.district
                } <br> ${cust.address.province}  <br> ${cust.address.zipcode}`;
            let shop = order.shop;
            let senderInfoTxt = [
                shop.name,
                `(${shop.phoneNo})`,
                shop.address.address,
                shop.address.district,
                shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a).join("<br>")

            let itemListTxt = "";
            for (const sku in order.products) {
                itemListTxt += `${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} <br>`;
            }

            let message = null;
            const isRemoteOrTouristArea = checkSurcharge(null, order.shippingMethod, cust.address.zipcode);
            if (isRemoteOrTouristArea) itemListTxt += "**พื้นที่ห่างไกล/พื้นที่ท่องเที่ยว**";

            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let username = order.user;

            let html = `
        <div style="width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black;">
                    <table
                           style="border-collapse:collapse; width: 100%; text-align: center;">
                        <tr>
                            <td rowspan="2" style="border: 1px solid black;">
                                <img src="data:image/png;base64,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" width="40" />
                            </td>
                            <td style="border: 1px solid black;">
                                <span style="font-size: 16px; font-weight: bold;">${order.shipperInfo ? order.shipperInfo.presortOption : ""}</span>
                            </td>
                            <td style="border: 1px solid black; line-height: 10px">
                                <span style="font-size: 10px;">DC</span>
                                    <br>
                                    <span style="font-size: 12px; font-weight: bold;">
                                    ${order.shipperInfo ? order.shipperInfo.dc : ""}
                                </span>
                            </td>
                            <td rowspan="3" colspan="2" style="border: 1px solid black;">
                                <img style="margin-bottom: -7px; width:100%; max-width: 150px;" src="${textToImage({
                bcid: 'qrcode',
                text: order.trackingNo,
                scale: 4,
            })}"/>
                            </td>
                        </tr>
                        <tr>
                            <td style="border: 1px solid black;">
                                <span style="font-size: 16px; font-weight: bold;">${order.shipperInfo ? order.shipperInfo.serviceCode : ""}</span>
                            </td>
                            <td style="line-height: 10px; border: 1px solid black;">
                                <span style="font-size: 10px;">DEL ROUTE</span>
                                <br>
                                <span style="font-size: 12px; font-weight: bold;">
                                ${order.shipperInfo ? order.shipperInfo.delRoute : ""}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" style="text-align: center; border: 1px solid black; padding-top: ">
                                <img style="margin-bottom: -7px" src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 1,
                height: 11,
            })}"/>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3" style="border: 1px solid black;">
                                <span style="font-size: 16px; font-weight: bold;">${order.trackingNo}</span>
                            </td>
                            <td style="border: 1px solid black;">
                                <span style="font-size: 16px; font-weight: bold;">
                                    ${order.codAmount && order.codAmount > 0 ? "COD" : ""}
                                </span>
                            </td>
                            <td style="border: 1px solid black;">
                                <span style="font-size: 16px; font-weight: bold;">1 OF 1</span>
                            </td>
                        </tr>
                    </table>
        
                    <table border="0"
                           style="border-collapse:collapse; width: 100%;">
                        <tr>
                            <td style="font-size: 12px; border: 1px solid black;">
                                ${senderInfoTxt}
                            </td>
        
                            <td valign="top" style="font-size: 12px; padding-left: 0.15in; border: 1px solid black;">
                                ${receiverInfoTxt}
                            </td>
                        </tr>
                        <tr>
                        <td style="font-size: 16px;">
                            ${order.codAmount ? `เก็บเงิน: ${order.codAmount}` : ''}
                        </td>
                        
                        <td colspan="2"
                            style="text-align: right; font-size: 12px">
                            ${username} &nbsp; ${currentDateTime}
                        </td>
                        </tr>
                        <tr>
                            <td>
                                <span style="font-size: 16px; font-weight: bold;">${order.customer.address.subDistrict}</span>
                            </td>
                            <td>
                                <table
                                       style="border-collapse:collapse; width: 100%; text-align: center; font-size: 16px; font-weight: bold;">
                                    <tr>
                                        ${zipChars.map(c => `<td style="border: 1px solid black;">${c}</td>`).join("")}
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>

                    <p style="margin: 0; font-size: 24px; font-weight: bold; border-top: 1px solid black; border-bottom: 1px solid black;">
                        ${order.shipperInfo ? order.shipperInfo.lineHual : ""}
                    </p>
              
                    <p style="font-size: 12px; border-bottom: 1px solid black;">
                        ${order.remarks}
                    </p>
             

                    <p style="font-size: 12px; padding-left: 2px;">
                        ${itemListTxt}
                    </p>
                </div>`

            return html
        },

        "thaipost": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")

            let shop = order.shop;
            let senderInfoTxt = [
                shop.name,
                `(${shop.phoneNo})`,
                shop.address.address,
                shop.address.district,
                shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")

            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }

            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }

            let touristAreaMessage = "";
            const isRemoteOrTouristArea = checkSurcharge(null, order.shippingMethod, cust.address.zipcode);
            if (isRemoteOrTouristArea) touristAreaMessage += "**พื้นที่ห่างไกล/พื้นที่ท่องเที่ยว**";

            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let html = `
        <div style="position: relative; width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black; padding: 2px">
                    <table border="0"
                           style="border-collapse:collapse; width: 100%; text-align: center;">
                        <tr>
                            <td style="width: 60%; text-align: left;">
                            <img src="https://app.proship.co.th/img/thaipost.f44555ee.png" height="40" />

                            <p style="font-weight: bold; font-size: 14px"> ผู้ส่ง </p>
                            <p style="font-size: 12px; line-height: 16px; margin-bottom: 4px;"> 
                                ${senderInfoTxt}
                            </p>

                            <p style="margin-bottom: 0;">
                                ผู้รับ โทร (${cust.phoneNo})
                            </p>

                            <p style="font-size: 12px; margin-top: 4px">
                                ${receiverInfoTxt}
                            </p>
                            
                            </td>

                            <td valign="top" align="right">
                                <div style="border: 1px solid black; padding: 2px; text-align: center; font-size: 8px">
                                    บริการจัดส่งสินค้า (e-Commerce)
                                    <br>
                                    ใบอนุญาตสำาหรับลูกค้าธุรกิจ
                                    <br>
                                    <span style="font-weight: bold"> ${order.licenseNo || "รล. 00/2563"} </span>
                                    <br>
                                    ชำาระค่าฝากส่งตามที่ ปณท กำาหนด
                                </div>

                                 <div style="border: 1px solid black; padding: 2px; margin-top: 3px; text-align: center; font-size: 8px">
                                    ทำารายการผ่านระบบ PROSHIP
                                </div>

                                <table style="margin-top: 0.9in">
                                    <tr>
                                        <td align="right">
                                            <div style="height: 70px; width: 70px; background-color: black; color: white; text-align: center; line-height: -1px; font-size: 50px;">
                                    ${order.trackingNo.charAt(0)}
                                </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="right">
                                            <span style="font-size: 32px"> ${cust.address.zipcode} </span>
                                        </td>
                                    </tr>
                                </table>

                            </td>
                        </tr>
                    </table>

                    <!-- products -->
                    <p style="margin: 0; font-size: 12px; font-weight: bold; padding-left: 2px;"> รายการสินค้า </p>
                    <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
                        ${productsHtml}
                    </table>

                    <div style="width: 100%; border-bottom: 1px solid black; font-size: 12px; height: 0.5in; margin-top: 10px;">
                        ${order.remarks}
                    </div>
                    

                    <div style="position: absolute; bottom: 0; left: 0; padding-left: 20px; padding-right: 20px">
                        
                        <div style="display: flex; justify-content: space-between; ">
                            <p style="font-size: 8px; margin: 0;"></p>
                            <p style="font-size: 12px; margin: 0;">${currentDateTime}</p>
                        </div>

                        <img src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 2,
                height: 8,
            })}" />

            <p style="font-weight: bold; font-size: 16px; margin-bottom: 0; margin-top: -6px; float: left"> ${order.trackingNo} </p>

            <p style="float: right; font-size: 12px; margin-bottom: 0; margin-top: -6px;">
                ${touristAreaMessage}
            </p>

        </div>
   </div>`

            return html
        },

        "thaipost-cod": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")

            let shop = order.shop;
            let senderInfoTxt = [
                shop.name,
                `(${shop.phoneNo})`,
                shop.address.address,
                shop.address.district,
                shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")

            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }

            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }

            let touristAreaMessage = "";
            const isRemoteOrTouristArea = checkSurcharge(null, order.shippingMethod, cust.address.zipcode);
            if (isRemoteOrTouristArea) touristAreaMessage += "**พื้นที่ห่างไกล/พื้นที่ท่องเที่ยว**";

            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let html = `
        <div style="position: relative; width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black; padding: 2px">
                    <table border="0"
                           style="border-collapse:collapse; width: 100%; text-align: center;">
                        <tr>
                            <td style="width: 60%; text-align: left;">
                                <img src="https://app.proship.co.th/img/thaipost.f44555ee.png" height="40" />

                                <p style="font-weight: bold; font-size: 14px"> ผู้ส่ง </p>
                                <p style="font-size: 12px; line-height: 16px; margin-bottom: 4px;"> 
                                    ${senderInfoTxt}
                                </p>
                            </td>

                            <td valign="top" align="right">
                                <div style="border: 1px solid black; padding: 2px; text-align: center; font-size: 8px">
                                    บริการจัดส่งสินค้า (e-Commerce)
                                    <br>
                                    ใบอนุญาตสำาหรับลูกค้าธุรกิจ
                                    <br>
                                    <span style="font-weight: bold"> ${order.licenseNo || "รล. 00/2563"} </span>
                                    <br>
                                    ชำาระค่าฝากส่งตามที่ ปณท กำาหนด
                                </div>

                                 <div style="border: 1px solid black; padding: 2px; margin-top: 3px; text-align: center; font-size: 8px">
                                    ทำารายการผ่านระบบ PROSHIP
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="2">
                                <div style="width: 98.5%; text-align: center; font-size: 16px; border: 1px solid black; padding: 2px;">
                                    COD แดง เก็บเงินปลายทาง
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td valign="top" align="left">
                                <p style="margin: 0;">
                                    ผู้รับ โทร (${cust.phoneNo})
                                </p>
                                <p style="font-size: 12px; margin-top: 4px; margin-bottom: 0;">
                                    ${receiverInfoTxt}
                                </p>
                            </td>

                            <td valign="top" align="right">
                                  <table>
                                    <tr>
                                        <td align="right">
                                            <div style="height: 70px; width: 70px; background-color: black; color: white; text-align: center; line-height: -1px; font-size: 50px;">
                                    ${order.trackingNo.charAt(0)}
                                </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="right">
                                            <span style="font-size: 32px"> ${cust.address.zipcode} </span>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>

                    <div style="width: 98%; text-align: center; font-size: 16px; border: 1px solid black; padding: 2px;">
                                COD &nbsp; &nbsp; &nbsp; เก็บเงิน &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ฿${order.codAmount}
                            </div>

                    <!-- products -->
                    <p style="margin: 0; font-size: 12px; font-weight: bold; padding-left: 2px;"> รายการสินค้า </p>
                    <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
                        ${productsHtml}
                    </table>

                    <div style="width: 99%; border: 1px solid black; font-size: 10px; margin-top: 5px;">
                        ${order.remarks.length > 180 ? order.remarks.slice(0, 180) : order.remarks}
                    </div>

                    <div style="position: absolute; bottom: 0; left: 0; padding-left: 20px; padding-right: 20px">
                        <div style="display: flex; justify-content: space-between; ">
                            <p style="font-size: 8px; margin: 0;"> Wallet ID เบอร์ผู้ส่ง: ${shop.walletId} </p>
                            <p style="font-size: 12px; margin: 0;">${currentDateTime}</p>
                        </div>

                        <img src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 2,
                height: 8,
            })}" />
            <p style="font-weight: bold; font-size: 16px; margin-bottom: 0; margin-top: -6px; float: left"> ${order.trackingNo} </p>

            <p style="float: right; font-size: 12px; margin-bottom: 0; margin-top: -6px;">
                ${touristAreaMessage}
            </p>
                    </div>
                </div>`

            return html
        },

        "thaipost0": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")

            let shop = order.shop;
            let senderInfoTxt = [
                shop.name,
                `(${shop.phoneNo})`,
                shop.address.address,
                shop.address.district + " " + shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")

            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }


            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }

            let touristAreaMessage = "";
            const isRemoteOrTouristArea = checkSurcharge(null, order.shippingMethod, cust.address.zipcode);
            if (isRemoteOrTouristArea) touristAreaMessage += "**พื้นที่ห่างไกล/พื้นที่ท่องเที่ยว**";

            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let html = `
        <div style="width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black; padding: 2px">
                    <table border="0"
                           style="border-collapse:collapse; width: 100%; text-align: center;">
                        <tr>
                            <td style="width: 60%; text-align: left;">
                             <img src="https://app.proship.co.th/img/thaipost.f44555ee.png" height="40" />


                            <p style="font-weight: bold; font-size: 14px"> ผู้ส่ง </p>
                            <p style="font-size: 12px; line-height: 16px; margin-bottom: 4px;"> 
                                ${senderInfoTxt}
                            </p>

                            <p style="margin-bottom: 0;">
                                ผู้รับ โทร (${cust.phoneNo})
                            </p>

                            <p style="font-size: 12px; margin-top: 4px">
                                ${receiverInfoTxt}
                            </p>
                            
                            </td>

                            <td valign="top" align="right">
                                <img src="https://app.proship.co.th/img/eps.8f4cedf9.png" width="90" />

                                <table style="margin-top: 0.9in">
                                    <tr>
                                        <td align="right">
                                            <div style="height: 70px; width: 70px; background-color: black; color: white; text-align: center; line-height: -1px; font-size: 50px;">
                                    ${order.trackingNo.charAt(0)}
                                </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="right">
                                            <span style="font-size: 32px"> ${cust.address.zipcode} </span>
                                        </td>
                                    </tr>
                                </table>

                            </td>
                        </tr>
                    </table>

                    <!-- products -->
                    <p style="margin: 0; font-size: 12px; font-weight: bold; padding-left: 2px;"> รายการสินค้า </p>
                    <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
                        ${productsHtml}
                    </table>

                    <div style="width: 100%; border-bottom: 1px solid black; font-size: 12px; height: 0.5in; margin-top: 10px;">
                        ${order.remarks}
                    </div>
                    

                    <div style="padding-left: 20px; padding-right: 20px">
                        <p style="font-size: 12px; margin: 0; text-align: right;">${currentDateTime}</p>
                        <img src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 2,
                height: 8,
            })}" />
            <p style="font-weight: bold; font-size: 16px; margin-bottom: 0; margin-top: -6px; float: left"> ${order.trackingNo} </p>

            <p style="float: right; font-size: 12px; margin-bottom: 0; margin-top: -6px;">
                ${touristAreaMessage}
            </p>
                    </div>
                </div>`

            return html
        },

        "thaipost0-cod": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")

            let shop = order.shop;
            let senderInfoTxt = [
                `${shop.name} (${shop.phoneNo})`,
                shop.address.address,
                shop.address.district + " " + shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")

            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }

            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }

            let touristAreaMessage = "";
            const isRemoteOrTouristArea = checkSurcharge(null, order.shippingMethod, cust.address.zipcode);
            if (isRemoteOrTouristArea) touristAreaMessage += "**พื้นที่ห่างไกล/พื้นที่ท่องเที่ยว**";

            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let html = `
        <div style="width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black; padding: 2px">
                    <table border="0"
                           style="border-collapse:collapse; width: 100%; text-align: center;">
                        <tr>
                            <td style="width: 60%; text-align: left;">
                                <img src="https://app.proship.co.th/img/thaipost.f44555ee.png" height="40" />

                                <p style="font-weight: bold; font-size: 14px"> ผู้ส่ง </p>
                                <p style="font-size: 12px; line-height: 16px; margin-bottom: 4px;"> 
                                    ${senderInfoTxt}
                                </p>
                            </td>

                            <td valign="top" align="right">
                                <img src="https://app.proship.co.th/img/eps.8f4cedf9.png" width="90" />
                            </td>
                        </tr>

                        <tr>
                            <td colspan="2">
                                <div style="width: 98.5%; text-align: center; font-size: 16px; border: 1px solid black; padding: 2px;">
                                    COD แดง เก็บเงินปลายทาง
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td valign="top" align="left">
                                <p style="margin: 0;">
                                    ผู้รับ โทร (${cust.phoneNo})
                                </p>
                                <p style="font-size: 12px; margin-top: 4px; margin-bottom: 0;">
                                    ${receiverInfoTxt}
                                </p>
                            </td>

                            <td valign="top" align="right">
                                  <table>
                                    <tr>
                                        <td align="right">
                                            <div style="height: 70px; width: 70px; background-color: black; color: white; text-align: center; line-height: -1px; font-size: 50px;">
                                    ${order.trackingNo.charAt(0)}
                                </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="right">
                                            <span style="font-size: 32px"> ${cust.address.zipcode} </span>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>

                    <div style="width: 98%; text-align: center; font-size: 16px; border: 1px solid black; padding: 2px;">
                                COD &nbsp; &nbsp; &nbsp; เก็บเงิน &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ฿${order.codAmount}
                            </div>

                    <!-- products -->
                    <p style="margin: 0; font-size: 12px; font-weight: bold; padding-left: 2px;"> รายการสินค้า </p>
                    <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
                        ${productsHtml}
                    </table>

                    <div style="width: 99%; border: 1px solid black; font-size: 12px; margin-top: 5px;">
                        ${order.remarks}
                    </div>
                    

                    <div style="padding-left: 20px; padding-right: 20px">
                        <p style="font-size: 12px; margin: 0; text-align: right;">${currentDateTime}</p>
                        <img src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 2,
                height: 8,
            })}" />

            <p style="font-weight: bold; font-size: 16px; margin-bottom: 0; margin-top: -6px; float: left"> ${order.trackingNo} </p>

            <p style="float: right; font-size: 12px; margin-bottom: 0; margin-top: -6px;">
                ${touristAreaMessage}
            </p>
                    </div>
                </div>`

            return html
        },

        "proship19": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")

            let shop = order.shop;
            let senderInfoTxt = [
                shop.name,
                `(${shop.phoneNo})`,
                shop.address.address,
                shop.address.district + " " + shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")

            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }


            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }

            let touristAreaMessage = "";
            const isRemoteOrTouristArea = checkSurcharge(null, order.shippingMethod, cust.address.zipcode);
            if (isRemoteOrTouristArea) touristAreaMessage += "**พื้นที่ห่างไกล/พื้นที่ท่องเที่ยว**";

            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let html = `
        <div style="width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black; padding: 2px">
                    <table border="0"
                           style="border-collapse:collapse; width: 100%; text-align: center;">
                        <tr>
                            <td style="width: 60%; text-align: left;">
                             <img src="https://app.proship.co.th/img/proship19.dd1ed1a0.png" height="40" />

                            <p style="font-weight: bold; font-size: 14px"> ผู้ส่ง </p>
                            <p style="font-size: 12px; line-height: 16px; margin-bottom: 4px;"> 
                                ${senderInfoTxt}
                            </p>

                            <p style="margin-bottom: 0;">
                                ผู้รับ โทร (${cust.phoneNo})
                            </p>

                            <p style="font-size: 12px; margin-top: 4px">
                                ${receiverInfoTxt}
                            </p>
                            
                            </td>

                            <td valign="top" align="right">
                                <div style="border: 1px solid black; width: 90px; height: auto;">
                                    <span style="font-size: 16px"> รหัส CA POS </span>
                                    <span style="font-size: 28px; font-style: bold;"> 4906 </span>
                                </div>

                                <table style="margin-top: 0.9in">
                                    <tr>
                                        <td align="right">
                                            <div style="height: 70px; width: 70px; background-color: black; color: white; text-align: center; line-height: -1px; font-size: 50px;">
                                    ${order.trackingNo.charAt(0)}
                                </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="right">
                                            <span style="font-size: 32px"> ${cust.address.zipcode} </span>
                                        </td>
                                    </tr>
                                </table>

                            </td>
                        </tr>
                    </table>

                    <!-- products -->
                    <p style="margin: 0; font-size: 12px; font-weight: bold; padding-left: 2px;"> รายการสินค้า </p>
                    <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
                        ${productsHtml}
                    </table>

                    <div style="width: 100%; border-bottom: 1px solid black; font-size: 12px; height: 0.5in; margin-top: 10px;">
                        ${order.remarks}
                    </div>
                    

                    <div style="padding-left: 20px; padding-right: 20px">
                        <p style="font-size: 12px; margin: 0; text-align: right;">${currentDateTime}</p>
                        <img src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 2,
                height: 8,
            })}" />
                <p style="font-weight: bold; font-size: 16px; margin-bottom: 0; margin-top: -6px; float: left"> ${order.trackingNo} </p>

            <p style="float: right; font-size: 12px; margin-bottom: 0; margin-top: -6px;">
                ${touristAreaMessage}
            </p>
                    </div>
                </div>`

            return html
        },

        "proship19-cod": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")

            let shop = order.shop;
            let senderInfoTxt = [
                `${shop.name} (${shop.phoneNo})`,
                shop.address.address,
                shop.address.district + " " + shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")

            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }

            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }

            let touristAreaMessage = "";
            const isRemoteOrTouristArea = checkSurcharge(null, order.shippingMethod, cust.address.zipcode);
            if (isRemoteOrTouristArea) touristAreaMessage += "**พื้นที่ห่างไกล/พื้นที่ท่องเที่ยว**";

            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let html = `
        <div style="width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black; padding: 2px">
                    <table border="0"
                           style="border-collapse:collapse; width: 100%; text-align: center;">
                        <tr>
                            <td style="width: 60%; text-align: left;">
                                <img src="https://app.proship.co.th/img/proship19.dd1ed1a0.png" height="40" />

                                <p style="font-weight: bold; font-size: 14px"> ผู้ส่ง </p>
                                <p style="font-size: 12px; line-height: 16px; margin-bottom: 4px;"> 
                                    ${senderInfoTxt}
                                </p>
                            </td>

                            <td valign="top" align="right">
                               <div style="border: 1px solid black; width: 90px; height: auto">
                                    <span style="font-size: 16px"> รหัส CA POS </span>
                                    <span style="font-size: 28px; font-style: bold;"> 4906 </span>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="2">
                                <div style="width: 98.5%; text-align: center; font-size: 16px; border: 1px solid black; padding: 2px;">
                                    COD แดง เก็บเงินปลายทาง
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td valign="top" align="left">
                                <p style="margin: 0;">
                                    ผู้รับ โทร (${cust.phoneNo})
                                </p>
                                <p style="font-size: 12px; margin-top: 4px; margin-bottom: 0;">
                                    ${receiverInfoTxt}
                                </p>
                            </td>

                            <td valign="top" align="right">
                                  <table>
                                    <tr>
                                        <td align="right">
                                            <div style="height: 70px; width: 70px; background-color: black; color: white; text-align: center; line-height: -1px; font-size: 50px;">
                                    ${order.trackingNo.charAt(0)}
                                </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="right">
                                            <span style="font-size: 32px"> ${cust.address.zipcode} </span>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>

                    <div style="width: 98%; text-align: center; font-size: 16px; border: 1px solid black; padding: 2px;">
                                COD &nbsp; &nbsp; &nbsp; เก็บเงิน &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ฿${order.codAmount}
                            </div>

                    <!-- products -->
                    <p style="margin: 0; font-size: 12px; font-weight: bold; padding-left: 2px;"> รายการสินค้า </p>
                    <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
                        ${productsHtml}
                    </table>

                    <div style="width: 99%; border: 1px solid black; font-size: 12px; margin-top: 5px;">
                        ${order.remarks}
                    </div>
                    

                    <div style="padding-left: 20px; padding-right: 20px">
                        <p style="font-size: 12px; margin: 0; text-align: right;">${currentDateTime}</p>
                        <img src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 2,
                height: 8,
            })}" />
                        <p style="font-weight: bold; font-size: 16px; margin-bottom: 0; margin-top: -6px; float: left"> ${order.trackingNo} </p>

            <p style="float: right; font-size: 12px; margin-bottom: 0; margin-top: -6px;">
                ${touristAreaMessage}
            </p>
                    </div>
                </div>`

            return html
        },

        "jt": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")

            let shop = order.shop;
            let senderInfoTxt = [
                shop.name,
                `(${shop.phoneNo})`,
                shop.address.address,
                shop.address.district,
                shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")

            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }

            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }

            let message = null;
            const isRemoteOrTouristArea = checkSurcharge(null, order.shippingMethod, cust.address.zipcode);
            if (isRemoteOrTouristArea) productsHtml += `<span style="font-size: 12px;"> **พื้นที่ห่างไกล/พื้นที่ท่องเที่ยว** </span>`;

            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let html = `
        <div style="width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black; padding: 2px; position: relative;">
        
        <table style="width: 100%">
            <tr>
                <td>
                    <img src="https://app.proship.co.th/img/jt.3e53e24b.png" height="40" />
                </td>
                <td valign="top" align="right">
                    <span style="font-size: 12px;">${currentDateTime}</span>
                </td>
            </tr>
        </table>

        <p style="margin: 0; text-align: center; font-size: 18px">
            ${order.trackingNo}
            <br>  
             <img src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 3,
                height: 6,
            })}" />
        </p>
        <p style="font-size: 24px; margin-top: -10px; margin-bottom: 0; text-align: center;"> ${order.sortingCode} </p>

        <p style="font-size: 12px; line-height: 16px; margin-bottom: 4px; border-top: 1px dashed black; border-bottom: 1px dashed black; margin-top: 0;"> 
            ผู้ส่ง
            <br>
            ${senderInfoTxt}
        </p>

        <p style="margin-bottom: 0; font-size: 14px; border-bottom: 1px dashed black; margin-top: 0; position: relative;">
            ผู้รับ โทร (${cust.phoneNo})
            <br>
            ${receiverInfoTxt}

            <span style="position: absolute; bottom: 10px; right: 10px; font-size: 18px;">
                ${cust.address.zipcode}
            </span>
         </p>

         <p style="margin-bottom: 0; font-size: 12px; border-bottom: 1px dashed black; margin-top: 0;">
           ${order.remarks}
         </p>

         <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
            ${productsHtml}
         </table>
        </div>`
            return html
        },

        "jt-cod": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")

            let shop = order.shop;
            let senderInfoTxt = [
                shop.name,
                `(${shop.phoneNo})`,
                shop.address.address,
                shop.address.district,
                shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")

            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }

            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }

            let message = null;
            const isRemoteOrTouristArea = checkSurcharge(null, order.shippingMethod, cust.address.zipcode);
            if (isRemoteOrTouristArea) productsHtml += `<span style="font-size: 12px;"> **พื้นที่ห่างไกล/พื้นที่ท่องเที่ยว** </span>`;

            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let html = `
        <div style="width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black; padding: 2px; position: relative;">
        
        <table style="width: 100%">
            <tr>
                <td>
                    <img src="https://app.proship.co.th/img/jt.3e53e24b.png" height="40" />
                </td>
                <td valign="top" align="right">
                    <span style="font-size: 12px;">${currentDateTime}</span>
                </td>
            </tr>
        </table>

        <p style="margin: 0; text-align: center; font-size: 18px">
            ${order.trackingNo}
            <br>  
             <img src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 3,
                height: 6,
            })}" />
        </p>
        <p style="font-size: 28px; margin-top: -10px; margin-bottom: 0; text-align: center;"> ${order.sortingCode} </p>

        <p style="font-size: 12px; line-height: 16px; margin-bottom: 4px; border-top: 1px dashed black; border-bottom: 1px dashed black; margin-top: 0;"> 
            ผู้ส่ง
            <br>
            ${senderInfoTxt}
        </p>

        <p style="margin-bottom: 0; font-size: 14px; border-bottom: 1px dashed black; margin-top: 0; position: relative;">
            ผู้รับ โทร (${cust.phoneNo})
            <br>
            ${receiverInfoTxt}

            <span style="position: absolute; bottom: 5px; right: 5px; font-size: 18px; line-height: 16px">
            COD
            <br>
            ฿${order.codAmount}
            <br>
            <br>
                ${cust.address.zipcode}
            </span>
         </p>

         <p style="margin-bottom: 0; font-size: 12px; border-bottom: 1px dashed black; margin-top: 0;">
           ${order.remarks}
         </p>

         <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
            ${productsHtml}
         </table>

         <div style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-45deg);
            font-size: 120px;
            color: rgba(200, 200, 200, 0.2);
            white-space: nowrap;
            z-index: -1;
            pointer-events: none;">
            COD
        </div>

        </div>`
            return html
        },

        "shopee": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")

            let shop = order.shop;
            let senderInfoTxt = [
                shop.name,
                `(${shop.phoneNo})`,
                shop.address.address,
                shop.address.district,
                shop.address.subDistrict,
                shop.address.province,
                shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")

            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }

            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }

            let message = null;
            const isRemoteOrTouristArea = checkSurcharge(null, order.shippingMethod, cust.address.zipcode);
            if (isRemoteOrTouristArea) productsHtml += `<br/><span style="font-size: 12px;"> **พื้นที่ห่างไกล/พื้นที่ท่องเที่ยว** </span>`;

            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");

            let html = `
        <div style="width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black;">
                    <table>
                        <tr>
                            <td style="width: 30%; text-align: left;">
                                <img src="https://app.proship.co.th/img/shopee.90a9a6ae.png" height="40" />
                            </td>

                            <td style="width: 70%;">
                                <img style="width: 100%;" src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 2,
                height: 8,
            })}" />
                                <p style="font-size: 12px; margin: 0; margin-top: -4px; text-align: center;"> ${order.trackingNo} </p>
                            </td>
                        </tr>
                    </table>

                    <table border="1" style="border-collapse:collapse; width: 100%;">
                        <tr>
                            <td style="width: 70%; padding: 2px;">
                                <p style="font-size: 12px; line-height: 16px; margin: 0;"> 
                                    <span style="font-size: 14px"> ผู้ส่ง </span>
                                    <br>
                                    ${senderInfoTxt}
                                </p>
                            </td>

                            <td valign="top">
                                <div style="width: 100%; height: 30px; line-height: 30px; background-color: black; color: white; text-align: center">
                                    ${({ 1: 'Pickup', 2: 'Dropoff' }[order.serviceType]) || ""}
                                </div>

                                <div style="width: 100%; height: 20px; line-height: 20px; color: black; font-size: 8px; text-align: center; border: 1px solid black; box-sizing: border-box;">
                                    ${order.return_first_sort_code}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p style="font-size: 12px; margin: 0">
                                    <span style="font-size: 12px">  ผู้รับ โทร (${cust.phoneNo}) </span>
                                    <br>
                                    ${receiverInfoTxt}
                                </p>
                            </td>
                            <td valign="bottom">
                                <div style="width: 100%; height: 30px; line-height: 30px; background-color: gray; color: white; text-align: center">
                                    ${order.r_first_sort_code.charAt(0).toUpperCase()}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p style="font-size: 8px; margin: 0; column-count: 2; column-gap: 2rem;">
                                    ${order.remarks.replace("หมายเหตุ:", "หมายเหตุ:<br>").replaceAll('\n', '<br>')}
                                </p>
                            </td>
                            <td valign="bottom" style="text-align: center;">
                                    ${order.codAmount ? `COD <br> ฿${order.codAmount}` : "ไม่ต้องเก็บเงิน"}
                            </td>
                        </tr>
                    </table>

                    <table border="1" style="border-collapse:collapse; width: 100%;">
                        <tr>
                            <td style="width: 20%">
                                <img style="margin-bottom: -7px" src="${textToImage({
                bcid: 'qrcode',
                text: order.trackingNo,
                scale: 2,
            })}"/>
                            </td>
                            <td valign="top" style="width: 80%">
                                <div style="position: relative; width: 100%; line-height: 30px; background-color: black; color: white; padding: 4px; box-sizing: border-box;">

                                    <p style="margin: 0; line-height: 20px;">
                                        ${cust.address.district}
                                        <br>
                                        ${order.r_first_sort_code}
                                    </p>
                                    <span style="position: absolute; right: 10px; top: 10px; font-size: 24px;"> NS </span>
                                </div>

                                <div style="width: 100%; line-height: 15px; padding: 4px; box-sizing: border-box; border: 1px solid black; font-size: 12px;">
                                    ทำรายการด้วยระบบ PROSHIP
                                    <br>
                                    ${currentDateTime}
                                </div>

                            </td>
                        </tr>
                    </table>

                    <!-- products -->
                    <p style="margin: 0; font-size: 12px; font-weight: bold; padding-left: 2px;"> รายการสินค้า </p>
                    <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
                        ${productsHtml}
                    </table>

                </div>`

            return html
        },

        "flash": () => {
            let cust = order.customer;
            let receiverInfoTxt = [
                `${cust.name} (${cust.phoneNo})`,
                cust.address.address,
                cust.address.subDistrict,
                cust.address.district,
                cust.address.province
            ].filter(a => a && a.length).join("<br>")
            let shop = order.shop;
            let senderInfoTxt = [
                `${shop.name} (${shop.phoneNo})`,
                shop.address.address,
                shop.address.district + ", " + shop.address.subDistrict,
                shop.address.province + ", " + shop.address.zipcode
            ].filter(a => a && a.length).join("<br>")
            let shopSocialLinksTxt = "";
            if (shop.socialLinks) {
                Object.keys(shop.socialLinks).forEach(
                    (key) => (shopSocialLinksTxt += shop.socialLinks[key] + "\n")
                );
            }
            let productsHtml = "";
            let c = 0;
            for (const sku in order.products) {
                if (c % 2 === 0) productsHtml += `<tr>`
                productsHtml += `<td> ${order.products[sku].sku || sku} ${order.products[sku].name} x ${order.products[sku].qty} </td>`;
                if (c % 2 !== 0) productsHtml += `</tr>`
                c++;
            }

            let message = null;
            const isRemoteOrTouristArea = checkSurcharge(null, order.shippingMethod, cust.address.zipcode);
            if (isRemoteOrTouristArea) productsHtml += `<br/><span style="font-size: 12px;"> **พื้นที่ห่างไกล/พื้นที่ท่องเที่ยว** </span>`;

            let currentDateTime = new Date().toLocaleString("en-GB", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");
            let html = `
        <div style="width: 3.74in; box-sizing: border-box; height: 5.75in; margin: 0.010in; border: 1px solid black; padding: 2px; position: relative;">
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
            
            <img src="data:image/png;base64,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" width="40" />

            <span style="font-size: 12px;">${currentDateTime}</span>
        </div>
        <div style="display: flex; align-items: center; justify-content: center;">
        ${order.sortingCode.split("-").map((t, i) => `<span style="font-size: ${i === 1 ? '40px' : '28px'};"> ${t} </span>`).join("&nbsp;-&nbsp;")}
        </div>
        <div style="display: flex; justify-content: center; margin-top: -12px;">
            <img src="${textToImage({
                bcid: "code128",
                text: order.trackingNo,
                scale: 2,
                height: 8,
            })}" width="90%" style="text-align: center" />
        </div>
        <p style="font-size: 20px; margin-top: -2px; margin-bottom: 0; text-align: center;"> ${order.trackingNo} </p>
        <table style="border-collapse:collapse; width: 100%; text-align: center;">
            <tr>
                <td colspan="2" align="left" style="padding-left: 4px; border: 1px solid black;">
                    DST ${order.dstStoreName}
                </td>
            </tr>
            <tr>
                <td style="padding-left: 4px; text-align: left; font-size: 12px; border: 1px solid black;">
                    ผู้ส่ง
                    <br>
                    ${senderInfoTxt}
                </td>
                <td valign="center" style="width: 30%; background-color: black; color: white; font-size: 40px; border: 1px solid black;">
                    ${order.sortingLineCode}
                </td>
            </tr>
            <tr>
                <td colspan="2" align="left" style="padding-left: 4px; font-size: 12px; border: 1px solid black;">
                    ผู้รับ โทร (${cust.phoneNo})
                    <br>
                    ${receiverInfoTxt}
                </td>
            </tr>
        </table>
        ${order.codAmount ? `
            <table style="border-collapse:collapse; width: 100%; text-align: center;">
                <tr>
                    <td style="border: 1px solid black;">เก็บเงินค่าสินค้า</td>
                    <td style="border: 1px solid black;"> COD &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ฿${order.codAmount} </td>
                </tr>
            </table>
            `: ''}
         <p style="margin: 0; font-size: 12px; border: 1px solid black; padding-left: 4px;">
           ${order.remarks}
         </p>
         <table style='font-size: 11px; width: 100%' cellpadding="0" cellspacing="0">
            ${productsHtml}
         </table>
        </div>`
            return html
        },
    }

    let sm = order.shippingMethod
    if (["thaipost", "thaipost0", "jt"].includes(sm) && order.codAmount) sm += "-cod"
    return RENDERER[sm] ? RENDERER[sm]() : "";
}

async function renderAllLabels(orders, format = "normal") {

    let licenseNo = null;
    try {
        const { data } = await http.get(APP_URL("core-v2") + "/settings/thaipost-user")
        licenseNo = data.licenseNo;
    } catch (e) {
        console.log(e);
    }

    const classByFormat = {
        "normal": "grid-template-columns: 1fr;",
        "a4": "grid-template-columns: repeat(2, 1fr); grid-template-rows: repeat(2, auto)"
    }

    let html = `<div style="display: grid; ${classByFormat[format]}">`;
    for (const order of orders) {
        order.licenseNo = licenseNo;
        try {
            html += generateLabel(order);
        } catch (e) {
            console.log(e);
            continue;
        }
    }
    html += `</div>`;
    return html
}

export const printHtmlLabels = async (orders, format = "normal") => {
    let html = await renderAllLabels(orders, format)

    function OpenPrintReceiptPage(htmlContent) {
        const printWindow = window.open('', '_blank');
        if (printWindow) {
            printWindow.document.open();
            printWindow.document.write(htmlContent);
            printWindow.document.close();
            printWindow.onload = () => {
                printWindow.print();
                // printWindow.close();
            };
        } else {
            console.error('Popup blocked. Allow popups to print the content.');
        }
    }
    OpenPrintReceiptPage(`
<!DOCTYPE HTML>
<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="th" lang="th">
<head>
    <meta http-equiv="Content-Type" content="text/html" charset="UTF-8" />
    <meta http-equiv="Content-Language" content="th_TH" />

    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Fira+Code:wght@300..700&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Kanit:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
          rel="stylesheet">

    <title>Proship - labels</title>
    <body style='font-family: "Kanit", sans-serif;'> ${html} </body> 
</html>`)
}
